<template>
  <default-layout :breadcrumbs="breadcrumbs">
    <div class="connect-learn-page">
      <div class="container">
        <connect-how-it-works type="project" />
      </div>
    </div>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import DefaultHeadMixin from '@/mixins/defaultHead';
import ConnectHowItWorks from '@/components/connect/connect-how-it-works.vue';

export default {
  name: 'project-connect-cara-kerja',
  mixins: [DefaultHeadMixin],
  async fetch({ store }) {
    const url = 'https://agen.belirumah.co/layanan-agen/project-connect/cara-kerja';
    const title = 'Project Connect | Akses Project Primary Developer | Agen BeliRumah.co';
    const description =
      'Temukan project primary aktif, hubungi PIC resmi developer, dan perluas peluang penjualan properti melalui Project Connect';

    store.commit('head/SET_CONTENT', {
      title,
      meta: [
        { hid: 'description', name: 'description', content: description },
        { hid: 'og-url', property: 'og:url', content: url },
        { hid: 'og-type', property: 'og:type', content: 'website' },
        { hid: 'og-description', property: 'og:description', content: description },
      ],
      link: [{ rel: 'canonical', href: url, id: 'canonical' }],
    });
  },
  components: {
    DefaultLayout,
    ConnectHowItWorks,
  },
  computed: {
    breadcrumbs() {
      if (this.$route.query.mobile === 'true') return [];
      return [
        {
          text: this.$t('breadcrumb.homepage'),
          to: '/',
        },
        {
          text: 'Project Connect',
          to: '/layanan-agen/project-connect',
        },
        {
          text: 'Cara Kerja',
          to: this.$router.currentRoute.path,
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.connect-learn-page {
  min-height: 100vh;
  padding-bottom: 64px;
  background: linear-gradient(180deg, #fffafa 0%, #ffffff 36%, #ffffff 100%);
}
</style>
